const cardMenu = [
    {
      id: 0,
      title: "Backlog",
      short: "BACKLOG",
      type: "BACKLOG",
    },
    {
      id: 1,
      title: "To do",
      short: "To-DO",
      type: "TODO",
    },
    {
      id: 2,
      title: "In progress",
      short: "PROGRESS",
      type: "INP",
    },
    {
      id: 3,
      title: "Done",
      short: "DONE",
      type: "COMPLETED",
    },
  ];
  
  export { cardMenu };
  